/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
// import { colors } from "../../../../theme/color";
// import Buttons from "../../../Button/button.component";
import HomeProductsCard from "../HomeProductModal/HomeProductsCard";
import ViewAllCard from "./viewAllCards";

import {
  DigitalWallet,
  InvoiceId,
  PaymentLinkId,
  Peer2Peer,
} from "../../../../../public/assets";

import {
  HomeProductContainer,
  HomeProductWrapper,
  HomeProductHeader,
  HomeProductMapped,
  HomeProductHeaderText,
  HomeProductButtonContainer,
  HomeProductCardContainer,
  HomeProductCard,
} from "./homeProductSection.styles";
import { useNavigate } from "react-router-dom";

const HomeProductCards = [
  {
    id: 1,
    icon: "/assets/svg/paymentlinkId.svg",
    title: "Payment Link",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Create Payment Link",
    url: "/dashboard/add-product",
  },
  {
    id: 2,
    icon: "/assets/svg/invoiceId.svg",
    title: "Invoice   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Create Invoice",
  },
  {
    id: 3,
    icon: "/assets/svg/peer2peer.svg",
    title: "Peer-to-Peer   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 4,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 5,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 6,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 7,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 8,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
  {
    id: 9,
    icon: "/assets/svg/digitalWalletId.svg",
    title: "Digital Wallet   (Coming Soon)*",
    description:
      "Create a payment link in just a few clicks and share the link with your customers-no code required",
    buttonTitle: "Get Started",
  },
];

const index = () => {
  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);
  const [showAllCards, setShowAllCards] = useState<boolean>(false);
  const route = useNavigate();
  const handleClick = (id: number, url?: string) => {
    if (id === HomeProductCards.length) {
      setShowAllCards(true);
    } else {
      setSelectedCardId(id === selectedCardId ? null : id);
    }
    if (url) {
      console.log(url);
      route(url);
    }
  };

  return (
    <>
      <HomeProductWrapper>
        <HomeProductHeader>
          <HomeProductHeaderText>Our Products</HomeProductHeaderText>
        </HomeProductHeader>
        <HomeProductButtonContainer></HomeProductButtonContainer>
      </HomeProductWrapper>
      <HomeProductContainer>
        {/* <HomeProductHeaderText>Our Products</HomeProductHeaderText> */}
        <br />
        <HomeProductCardContainer>
          <HomeProductCard>
            {showAllCards
              ? HomeProductCards.map((cards) => (
                  <HomeProductMapped
                    key={cards.id}
                    length={cards.description.length}
                  >
                    <HomeProductsCard
                      cards={cards}
                      handleClick={handleClick}
                      isSelected={cards.id === selectedCardId}
                    />
                  </HomeProductMapped>
                ))
              : HomeProductCards.slice(0, 5).map((cards) => (
                  <HomeProductMapped
                    key={cards.id}
                    length={cards.description.length}
                  >
                    <HomeProductsCard
                      cards={cards}
                      handleClick={handleClick}
                      isSelected={cards.id === selectedCardId}
                    />
                  </HomeProductMapped>
                ))}
            {showAllCards || (
              <HomeProductMapped length={0}>
                <ViewAllCard handleClick={() => setShowAllCards(true)} />
              </HomeProductMapped>
            )}
          </HomeProductCard>
        </HomeProductCardContainer>
      </HomeProductContainer>
    </>
  );
};

export default index;
